import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useStyles = makeStyles({
    row: {
        position: 'relative',
        height: px(1),
        border: 'none',
        pointerEvents: 'none',
        userSelect: 'none',
    },
    cell: {
        height: px(1),
    },
    divider: {
        position: 'absolute',
        height: '100%',
        insetBlock: px(0),
        backgroundColor: tokens.colorNeutralStroke2,
    },
});
